import NewPassword from './containers/newpassword.container'

const routes = [
  { path: '/nova-senha', title: 'Redefinir sua senha', component: NewPassword },
]

export default routes
